<template>
  <div class="BookingsSold panel">
    <h4>Bookings Sold</h4>
    <div class="chart-container">
      <canvas ref="chart" />
    </div>
    <div class="info">
      <div class="count active">
        322
      </div>
      <div class="expl">
        Bookings sold
      </div>
    </div>

    <div class="info">
      <div class="count inactive">
        122
      </div>
      <div class="expl">
        Bookings not delivered yet
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  mounted() {
    const ctx = this.$refs.chart.getContext("2d");
    let myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: ["Active", "Inactive"],
        datasets: [
          {
            data: [322, 122],
            // borderColor: '#ef4266',
            backgroundColor: ["#7d60ff", "#ef4266"],
          },
        ],
      },
      options: {
        maintainAspectRatio: true,
        legend: { display: false },
      },
    });
    console.log(myChart);
  },
};
</script>

<style lang="scss" scoped>
.BookingsSold {
  display: flex;
  flex-direction: column;

  h4 {
    text-transform: uppercase;
  }

  .info {
    display: flex;
    align-items: center;
    padding-top: 2em;

    .count {
      font-size: 2.57em;
      font-weight: bold;
      padding-right: 5px;

      &.active {
        color: var(--periwinkle);
      }
      &.inactive {
        color: var(--red-pink);
      }
    }
  }
}
</style>
